import { Flame } from 'lucide-react';

const ITEMS = [
  'Carne feita na casa',
  'Feito com amor',
  'Pão de brioche ou australiano',
  'Molho especial da casa',
  'Sex & Sáb até às 2h',
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className="overflow-hidden border-y border-white/10 bg-[#16161A] py-5"
      data-testid="marquee-strip"
    >
      <div className="marquee-track items-center gap-10 pr-10">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-display text-2xl uppercase tracking-wider text-zinc-400 sm:text-3xl">
              {item}
            </span>
            <Flame size={18} className="shrink-0 text-[#FF5500]" />
          </span>
        ))}
      </div>
    </div>
  );
}
